<template>
    <router-view />
</template>

<script>
export default {
    name: 'PrintModule'
};
</script>
